import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './app/App'
import { AuthProvider } from './features/auth/AuthContext'
import { LocaleProvider } from './shared/i18n/LocaleContext'
import { installRemoteDownloadCacheBypass } from './shared/remoteDownload'
import './styles/global.css'
import './styles/settings.css'
import './styles/administration.css'
import './styles/models.css'
import './styles/datasets.css'
import './styles/companies.css'
import './styles/events.css'

installRemoteDownloadCacheBypass()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <LocaleProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </LocaleProvider>
    </BrowserRouter>
  </StrictMode>,
)
